import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

export const activityFields = {
  activities: {
    id: 'activities',
  },
  activityOther: {
    id: 'activityOther',
    label: 'Add another activity',
    type: 'text',
  },
};

export const getRules = () => ({
  [activityFields.activities.id]: yup.array()
    .typeError('Please select at least one activity')
    .min(1, 'Please select at least one activity')
    .required('Please select at least one activity'),
  // This rule is used to ensure that the user has entered an activity if they have selected 'other' as their only activity. But if they've got other activities selected, then this rule is ignored.
  [activityFields.activityOther.id]: yup.string()
    .when([activityFields.activities.id], {
      is: (activities: string[]) => Array.isArray(activities) && activities.includes('other') && activities.length === 1,
      then: schema => schema
        .required('Enter or select an activity to continue')
        .min(1, 'Enter or select an activity to continue'),
      otherwise: schema => schema.optional(),
    }),
});

export const getFormSchema = () => (
  yup.object().shape(getRules())
);

export const getFormResolver = () => (
  yupResolver(getFormSchema())
);

// Note: Values & Labels copied from react-donation:
// https://github.com/comicrelief/react-donation/blob/master/src/Pages/PayIn/data/activityData.js
export const activityOptions = {
  all: {
    fancy_dress: {
      label: 'Fancy Dress',
      testId: 'payinActivityFancyDress'
    },
    baking: {
      label: 'Baking',
      testId: 'payinActivityBaking'
    },
    sponsored_challenge: {
      label: 'Sponsored challenge',
      testId: 'payinActivitySponsoredChallenge'
    },
    quiz_games: {
      label: 'Quiz / games',
      testId: 'payinActivityQuizGames'
    },
    talent_show: {
      label: 'Talent show',
      testId: 'payinActivityTalentShow'
    },
    sport_activity: {
      label: 'Sport activity',
      testId: 'payinActivitySportActivity'
    },
    other: {
      label: 'Something else',
      testId: 'payinActivityOther'
    }
  },
  school: {
    fancy_dress: {
      label: 'Fancy Dress',
      testId: 'payinActivityFancyDress'
    },
    baking: {
      label: 'Baking',
      testId: 'payinActivityBaking'
    },
    sponsored_challenge: {
      label: 'Sponsored challenge',
      testId: 'payinActivitySponsoredChallenge'
    },
    quiz_games: {
      label: 'Quiz / games',
      testId: 'payinActivityQuizGames'
    },
    talent_show: {
      label: 'Talent show',
      testId: 'payinActivityTalentShow'
    },
    sport_activity: {
      label: 'Sport activity',
      testId: 'payinActivitySportActivity'
    },
    other: {
      label: 'Something else',
      testId: 'payinActivityOther'
    }
  },
  work: {
    fancy_dress: {
      label: 'Fancy Dress',
      testId: 'payinActivityFancyDress'
    },
    baking: {
      label: 'Baking',
      testId: 'payinActivityBaking'
    },
    sponsored_challenge: {
      label: 'Sponsored challenge',
      testId: 'payinActivitySponsoredChallenge'
    },
    quiz_games: {
      label: 'Quiz / games',
      testId: 'payinActivityQuizGames'
    },
    sport_activity: {
      label: 'Sport activity',
      testId: 'payinActivitySportActivity'
    },
    other: {
      label: 'Something else',
      testId: 'payinActivityOther'
    }
  },
  public: {
    fancy_dress: {
      label: 'Fancy Dress',
      testId: 'payinActivityFancyDress'
    },
    baking: {
      label: 'Baking',
      testId: 'payinActivityBaking'
    },
    sponsored_challenge: {
      label: 'Sponsored challenge',
      testId: 'payinActivitySponsoredChallenge'
    },
    quiz_games: {
      label: 'Quiz / games',
      testId: 'payinActivityQuizGames'
    },
    sport_activity: {
      label: 'Sport activity',
      testId: 'payinActivitySportActivity'
    },
    other: {
      label: 'Something else',
      testId: 'payinActivityOther'
    }
  },
};
